import React from 'react';

import { Button } from '../../components/Button/Button';
import { useInView } from '../../hooks/useInView';
import type { BrandPromo } from './slides';

import './BrandPromoSection.css';

type BrandPromoSectionProps = {
    data: BrandPromo;
};

function BrandTile({ brand, ariaHidden }: { brand: { name: string; logo: string }; ariaHidden?: boolean }) {
    return (
        <div className="fa-promo__brand faves-glass" aria-hidden={ariaHidden ? 'true' : undefined}>
            <img src={brand.logo} alt={ariaHidden ? '' : brand.name} className="fa-promo__brand-logo" />
        </div>
    );
}

export function BrandPromoSection({ data }: BrandPromoSectionProps) {
    const [ref, inView] = useInView<HTMLDivElement>();

    return (
        <section className="fa-promo">
            <div
                ref={ref}
                className={`fa-promo__hero faves-reveal-group${inView ? ' faves-reveal-group--in' : ''}`}
            >
                <h2 className="fa-promo__heading faves-display--light faves-reveal">{data.heading}</h2>
                <div className="fa-promo__right">
                    <p
                        className="fa-promo__body faves-body faves-reveal"
                        style={{ '--reveal-delay': '160ms' } as React.CSSProperties}
                    >
                        {data.body}
                    </p>
                    <span
                        className="faves-reveal"
                        style={{ '--reveal-delay': '280ms' } as React.CSSProperties}
                    >
                        <Button
                            label={data.cta.label}
                            href={data.cta.href}
                            variant="accent"
                            className="fa-promo__cta"
                        />
                    </span>
                </div>
            </div>
            <div className="fa-promo__marquee" aria-label="Featured brands">
                <div className="fa-promo__marquee-track">
                    {data.brands.map((brand, i) => (
                        <BrandTile key={`a-${i}`} brand={brand} />
                    ))}
                    {data.brands.map((brand, i) => (
                        <BrandTile key={`b-${i}`} brand={brand} ariaHidden />
                    ))}
                </div>
            </div>
        </section>
    );
}
